/**
 * Auto-generated file created by svgr-cli source svgr.template.config.js
 * Run yarn svgr to update
 * Do not edit
 */
import * as React from 'react'
import { SVGProps, memo } from 'react'
const SvgCaretDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width || 24}
    height={props.height || 24}
    fill="currentColor"
    color={props.color || '#EE4D2D'}
    {...props}
  >
    <path
      fill="currentColor"
      d="M9.849 3.516H2.152c-.231 0-.36.243-.217.41l3.848 4.462c.11.128.323.128.434 0l3.848-4.462c.143-.167.014-.41-.216-.41Z"
    />
  </svg>
)
const Memo = memo(SvgCaretDown)
export default Memo
